var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary","disabled":_vm.disabledDownload,"size":"small","icon":"el-icon-download"},on:{"click":_vm.packdownload}},[_vm._v("打包下载")])
}
var staticRenderFns = []

export { render, staticRenderFns }